import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

/**
 * Filtro padrão Ativos/Inativos/Todos, reutilizável em qualquer tela de
 * cadastro que já tenha um conceito de ativo/inativo (Clientes, Usuários,
 * Empresas, Produtos/Sistemas, Grupos etc.). Nunca inventa o campo — quem
 * usa este componente decide como "ativos"/"inativos" mapeiam para dados.
 *
 * Valores: "ativos" (default recomendado), "inativos", "todos".
 */
export default function StatusFiltro({ value, onChange, testId = "filtro-status", label = "Situação" }) {
  return (
    <div className="min-w-[160px]">
      <Label className="text-xs">{label}</Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="ativos">Ativo</SelectItem>
          <SelectItem value="inativos">Inativo</SelectItem>
          <SelectItem value="todos">Todos</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

export const STATUS_FILTRO_DEFAULT = "ativos";

export function statusFiltroPassa(statusFiltro, active) {
  if (statusFiltro === "ativos") return !!active;
  if (statusFiltro === "inativos") return !active;
  return true;
}
